import { ApolloClient, InMemoryCache, createHttpLink, from } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { createUploadLink } from "apollo-upload-client";
import { apiUrl } from "../config/appConfig";

// Regular HTTP link for non-upload operations
const httpLink = createHttpLink({
  uri: `${apiUrl}/graphql/`,
});

// Upload link for file upload operations
const uploadLink = createUploadLink({
  uri: `${apiUrl}/graphql/`,
});

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem("token");
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});

// Use uploadLink for all operations since it handles both regular and upload operations
const client = new ApolloClient({
  link: authLink.concat(uploadLink),
  cache: new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          // Handle pagination for products query
          products: {
            keyArgs: ["filters"],
            merge(existing, incoming, { args }) {
              const merged = existing ? { ...existing } : { items: [], pageInfo: {} };

              // If it's the first page or a refetch, replace all data
              if (!args?.pagination?.page || args.pagination.page === 1) {
                return incoming;
              }

              // For subsequent pages, append the new items
              return {
                ...incoming,
                items: [...(existing?.items || []), ...(incoming?.items || [])],
              };
            },
          },
          // Handle pagination for products by category
          productsByCategory: {
            keyArgs: ["categoryId"],
            merge(existing, incoming, { args }) {
              const merged = existing ? { ...existing } : { items: [], pageInfo: {} };

              // If it's the first page or a refetch, replace all data
              if (!args?.pagination?.page || args.pagination.page === 1) {
                return incoming;
              }

              // For subsequent pages, append the new items
              return {
                ...incoming,
                items: [...(existing?.items || []), ...(incoming?.items || [])],
              };
            },
          },
          // Handle products by brand (no pagination needed as it returns all)
          productsByBrand: {
            keyArgs: ["brandId"],
            merge(existing, incoming) {
              return incoming;
            },
          },
        },
      },
    },
  }),
});

export default client;
